module.exports = __webpack_public_path__ + "static/img/报告解读@3x.00d43de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medical/index/报告解读@3x.png
// module id = 771
// module chunks = 358